/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const PublicContest = {

	delete (context, contestId, onSuccess, onError, options) {
		Api.delete(context,
			"/public-contest"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteDacCodes (context, codeId, onSuccess, onError, options) {
		Api.delete(context,
			"/public-contest/dac-codes"
			+ "?codeId=" + codeId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteForm (context, contestId, contestFormType, onSuccess, onError, options) {
		Api.delete(context,
			"/public-contest/form"
			+ "?contestId=" + contestId
			+ "&contestFormType=" + contestFormType
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteReportForm (context, reportId, onSuccess, onError, options) {
		Api.delete(context,
			"/public-contest/report-form"
			+ "?reportId=" + reportId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteUser (context, contestUserId, onSuccess, onError, options) {
		Api.delete(context,
			"/public-contest/user"
			+ "?contestUserId=" + contestUserId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAgencyEvaluationNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/agency-evaluation-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllContestNames (context, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/all-contest-names"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllForms (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/all-forms"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllReports (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/all-reports"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBidderContestStats (context, bidderId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/bidder-contest-stats"
			+ "?bidderId=" + bidderId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCollaborationEvaluationNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/collaboration-evaluation-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCollaborationEvaluationPermissionData (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/collaboration-evaluation-permission-data"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCommitteeCollaborationEvaluationNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/committee-collaboration-evaluation-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestLegalForms (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/contest-legal-forms"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestLegalFormsPossibleBidders (context, contestId, legalFormList, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/contest-legal-forms/possible-bidders"
			+ "?contestId=" + contestId
			+ "&legalFormList=" + legalFormList
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestName (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/contest-name"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestNames (context, departmentId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/contest-names"
			+ "?departmentId=" + departmentId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestRole (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/contest-role"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestTerms (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/contest-terms"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDacCodes (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/dac-codes"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDacCodesAvailableToAdd (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/dac-codes-available-to-add"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDacCodesStatus (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/dac-codes/status"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getData (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/data"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataRequiredToExport (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/data-required-to-export"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataRequiredToExportEvaluations (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/data-required-to-export-evaluations"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataRequiredToExportFinalReports (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/data-required-to-export-final-reports"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataRequiredToExportMonitoringReports (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/data-required-to-export-monitoring-reports"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataRequiredToExportVolunteerReports (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/data-required-to-export-volunteer-reports"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDepartmentContests (context, departmentId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/department-contests"
			+ "?departmentId=" + departmentId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getEmptyOffer (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/empty-offer"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getEvaluationConstantFields (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/evaluation-constant-fields"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getEvaluationFormsInclusionStatus (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/evaluation-forms-inclusion-status"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getEvaluationSummaryView (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/evaluation-summary-view"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getExpertEvaluationNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/expert-evaluation-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getExperts (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/experts"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinalEvaluationNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/final-evaluation-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinalProtocolCanEdit (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/final-protocol-can-edit"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinalProtocolText (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/final-protocol-text"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinalReportConstantFields (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/final-report-constant-fields"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinalReportNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/final-report-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getForm (context, contestId, contestFormType, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/form"
			+ "?contestId=" + contestId
			+ "&contestFormType=" + contestFormType
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFormStatus (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/form-status"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFormalEvaluationNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/formal-evaluation-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getGeneralSettings (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/general-settings"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getIndividualEvaluationNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/individual-evaluation-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getIsContestAdministrator (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/is-contest-administrator"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getIsSecretary (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/is-secretary"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getIsSubstantiveOrFinalEvaluationPresent (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/is-substantive-or-final-evaluation-present"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getLegalFormMembership (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/legal-form-membership"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getModuleOfferNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/module-offer-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getMonitoringReportConstantFields (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/monitoring-report-constant-fields"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getMonitoringReportNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/monitoring-report-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getOfferConfiguration (context, offerId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/offer-configuration"
			+ "?offerId=" + offerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getOfferConstantFields (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/offer-constant-fields"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getOfferNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/offer-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getPanelInfo (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/panel-info"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getProjectConstantFields (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/project-constant-fields"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getProjects (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/projects"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getRatingSettings (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/rating-settings"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getReportForm (context, reportId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/report-form"
			+ "?reportId=" + reportId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getStatus (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/status"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSummaryMainData (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/summary-main-data"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSummaryUsersData (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/summary-users-data"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserRole (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/user-role"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUsers (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/users"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUsersAvailableToAdd (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/users-available-to-add"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getVolunteerReportConstantFields (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/volunteer-report-constant-fields"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getVolunteerReportForms (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/volunteer-report-forms"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getVolunteerReportNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/public-contest/volunteer-report-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, contestCreateDTO, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest"
			, contestCreateDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAnnounce (context, contestId, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/announce"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postChangeUserContestRole (context, contestUserId, role, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/change-user-contest-role"
			+ "?contestUserId=" + contestUserId
			+ "&role=" + role
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postDacCodes (context, contestId, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/dac-codes"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postDuplicateReportForm (context, loadReportSchemaDTO, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/duplicate-report-form"
			, loadReportSchemaDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postEvaluationExport (context, evaluationExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/evaluation-export"
			, evaluationExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postFinalEvaluation (context, contestId, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/final-evaluation"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postFinalProtocolText (context, contestId, textDTO, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/final-protocol-text"
			+ "?contestId=" + contestId
			, textDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postFinish (context, contestId, resultPage, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/finish"
			+ "?contestId=" + contestId
			+ "&resultPage=" + resultPage
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postForm (context, loadSchemaDTO, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/form"
			, loadSchemaDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postInitialRejection (context, contestId, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/initial-rejection"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postMultipleProjectsEvaluationExport (context, evaluationExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/multiple-projects-evaluation-export"
			, evaluationExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postOfferExport (context, contestId, offerExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/offer-export"
			+ "?contestId=" + contestId
			, offerExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postProjectEvaluationExport (context, projectId, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/project-evaluation-export"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postProjectExport (context, contestId, projectExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/project-export"
			+ "?contestId=" + contestId
			, projectExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postStartEvaluation (context, contestId, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/start-evaluation"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postSuppress (context, contestId, onSuccess, onError, options) {
		Api.post(context,
			"/public-contest/suppress"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putContestLegalForms (context, updateContestLegalFormsDTO, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/contest-legal-forms"
			, updateContestLegalFormsDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putDacCodes (context, contestId, codeId, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/dac-codes"
			+ "?contestId=" + contestId
			+ "&codeId=" + codeId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putDacCodesStatus (context, contestId, status, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/dac-codes/status"
			+ "?contestId=" + contestId
			+ "&status=" + status
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putData (context, updateContestDataDTO, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/data"
			, updateContestDataDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinalEvaluation (context, contestId, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/final-evaluation"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinalEvaluationPreview (context, contestId, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/final-evaluation-preview"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putForm (context, defineSchemaDTO, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/form"
			, defineSchemaDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFormInclusionStatus (context, saveInclusionStatusDTO, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/form-inclusion-status"
			, saveInclusionStatusDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFormStatus (context, statusDTO, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/form-status"
			, statusDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putGeneralSettings (context, contestId, settings, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/general-settings"
			+ "?contestId=" + contestId
			, settings
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putInitialRejection (context, contestId, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/initial-rejection"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putRatingSettings (context, contestId, settings, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/rating-settings"
			+ "?contestId=" + contestId
			, settings
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putReportForm (context, reportSchemaDTO, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/report-form"
			, reportSchemaDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putStartEvaluation (context, contestId, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/start-evaluation"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUser (context, contestId, contestUserId, onSuccess, onError, options) {
		Api.put(context,
			"/public-contest/user"
			+ "?contestId=" + contestId
			+ "&contestUserId=" + contestUserId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
